import ops from "@/assets/js/vuescrollOption";
import { nav, usersList } from "./navData";
import { roleHashNotice, noticeTypes } from "@/assets/js/status";
import { noticeDetail } from "@/api/notice/notice";
import { storageData } from "@/assets/js/storage";
export default {
  components: {
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-tips": () => import('@/components/Tips/Dialog'),
    "yioks-iKnow": () => import('@/components/Tips/iKnow'),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "notice-detail-dialog": () => import("./DetailDia"),
    "notice-users-dialog": () => import("./UsersList"),
  },
  filters: {
    userRole: (role) => roleHashNotice[role],
    noticeType: (type) => noticeTypes[type],
  },
  data() {
    const userInfo = storageData.getUserInfo();
    const getNav = () => {
      switch (userInfo.member_type) {
        case 'super':
        case 'system':
          return [nav.send, nav.all]
          break;
        case 'organ':
        case 'teacher':
        case 'student':
          return [nav.get]
          break;
        default:
          return []
          break;
      }
    }
    return {
      isSendNotice: new Set(['super','system']).has(userInfo.member_type),
      usersList,
      nav: getNav(),
      ops: ops(),
      page: 1,
      paging: {
        start: 0, // 每页从第几条数据开始
        prePage: 1, // 一页多少条数据
        total: 0, // 总数
        size: 3, // 页码显示限制
        last: true, // 尾页
        next: true, // 下一页
        first: true, // 首页
        previous: true, // 上一页
        jump: true
      },
      ifContentDiaShow: false,
      isLoading: true,
      showEmpty: false,
      noticeInfo: {
        document_list: [],
        notification: {}
      },
      selectVal: {
        keywords: "",
        start_time: "",
        end_time: "",
        user: ""
      },
      iKnow: {
        iKnowStatus: false,
        iKnowInfo: ""
      },
      detailIdx: null
    }
  },
  methods: {
    setData() {
      const { user, keywords, start_time, end_time, page } = this.$route.query;
      page && (this.page = page);
      keywords && this.$set(this.selectVal, "keywords", keywords);
      user && this.$set(this.selectVal, "user", user);
      start_time && this.$set(this.selectVal, "start_time", start_time);
      end_time && this.$set(this.selectVal, "end_time", end_time);
    },
    goBack() {
      this.$router.go(-1);
    },
    gotoPage(start) {
      this.page = parseInt(start / this.paging.prePage) + 1;
      this.changeQuery(false);
      this.$refs["vs"].scrollTo({ y: 0 });
    },
    changeQuery(flag) {
      flag && (this.page = 1);
      const route = this.$route;
      const selectVal = this.selectVal;
      this.$router.replace({
        path: route.path,
        query: {
          ...route.query,
          page: this.page,
          start_time: selectVal.start_time,
          end_time: selectVal.end_time,
          user: selectVal.user,
          keywords: selectVal.keywords
        }
      });
      this.request();
    },
    search() {
      this.changeQuery(true);
    },

    hideIcon() {
      this.$set(this.selectVal, "keywords", "");
      this.search();
    },

    navLink({ routerName }) {
      this.$router.replace({ name: routerName })
    },
    // 点击标题查看通知详情
    lookContent({ notification_id }, i) {
      this.noticeInfo.document_list = []
      this.noticeInfo.notification = {}
      noticeDetail({ notification_id }).then(({ data: { status, result } }) => {
        if (Number(status) === 0) {
          this.noticeInfo = result
        }
      }).catch(err => {
        console.error(err)
      })
      this.detailIdx = i;
      this.ifContentDiaShow = true;
    },
    closeDetail(ifClose, sure) {
      this.ifContentDiaShow = ifClose;
    },

  },
  computed: {
    searchTime() {
      return {
        disabledDate: time => (time.getTime() < Number(this.selectVal.start_time))
      };
    },
    searchStartTime() {
      return {
        disabledDate: time => {
          if(this.selectVal.end_time) {
            return time.getTime() > Number(this.selectVal.end_time)
          } else {
            return false
          }
        }
      }
    }
  }
}
